import React, { Component } from 'react';
import './index.scss';
import SvgZoomMap from '../../utils/SvgZoomMap';
import MapIsland from '../../utils/SvgZoomMapIsland';
import LoadingDots from '../../utils/LoadingDots';
import { range } from 'lodash';
import _ from 'lodash';
import { none } from 'ramda';
import * as d3 from 'd3';



class SviChartMap extends Component {
	constructor(params) {
		super(params);
		this.state = {
			isMapShow: false,
			isDataLoad: false,
			isColorMarkHide: false,
			colorSet: ['#e05066', '#fd7c8e', '#fd8a9b', '#fea2b0', '#febac4', '#fed4da', '#ffebed', '#ffffff', '#dee8fe', '#cad9fd', '#adc5fc', '#92b2fc', '#7ba1fb', '#6390fa', '#2867f9'],
			color1: '0, 43, 95',
			color2: '40, 129, 241',
			color3: '245, 255, 252',
			color4: '38, 202, 154',
			color5: '1, 74, 46',
			isBubbleShow: false,
			bubbleValue: '',
			bubbleName: '',
			bubbleTop: 0,
			bubbleLeft: 0,
			colorBar: '',
			zeroPositionPercent: '50',
			svgId :"svgMap"
		};
	}
	

	componentDidMount() {
		this.getRange();
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {			
			this.getRange();
			// this.handleLoadData();
			if (this.props.sviData.length === 0) {
				this.setState({
					isDataLoad: false					
				})
				
			}
			else {
				this.setState({
					isDataLoad: true
				})
				
			}
		}
	}
	getColorBar = (colorSet) => {
		const {zeroPositionPercent} = this.state;
		let colorBar = ''
		colorBar = colorSet[0] + `,#FFFFFF ${zeroPositionPercent}%,` + colorSet[colorSet.length-1]
		this.setState({colorBar})
	}
	getRange = () => {
		const { sviData } = this.props;
		if (sviData) {
			const { colorSet, zeroPositionPercent } = this.state;
			const num = colorSet.length + 1;
			const maximum = Math.max(...sviData.data.map(data => data.value));
			const minimum = Math.min(...sviData.data.map(data => data.value));
			const deltaP = 2 * maximum / (num - 2)
			const deltaN = 2 * (0 - minimum ) / (num - 1)
			const allDataIsNull = sviData.data.every(data => data.value === null);

			const ranges = [];
			for (let i = 0; i < num; i++) {
				const currentMin = Math.floor(minimum*100)
				const currentDeltaP = Math.floor(deltaP*100)
				const currentDeltaN = Math.floor(deltaN*100)
				let value;
				if(i < (num /2)) {
					value = currentMin + (currentDeltaN * i)
				}else {
					value = 0 + currentDeltaP * (i - (num-1)/2)
				}
				ranges.push(value/100);
			};
			ranges[0] = minimum
			ranges[ranges.length-1] = maximum
			
			
			this.setState({
				colors: colorSet,
				ranges: ranges,
				isColorMarkHide: allDataIsNull,
				zeroPositionPercent: Math.abs((minimum /(maximum - minimum)*100))
			}, () => {
				this.setColor(this.handleLoadData);				
			});			
		}
	}

	MapRest = () =>{		
		const mapNames = document.querySelector('#svgMap .map-names')
		if(mapNames){mapNames.innerHTML='';}
	}

	MapInit = () =>
	{	
		console.log('Map initialized');
		this.MapRest();
		this.AppendName();
	}

	AppendName = () => {
		const countys = document.querySelectorAll('#svgMap g .-county');
		const towns = document.querySelectorAll('#svgMap g .-town');
		const village = document.querySelectorAll('#svgMap g .-village');
		const mapNames = document.querySelector('#svgMap .map-names');
		const scaleNum = this.ScaleNum();
		let fontSize = 15 * scaleNum;
		const places = [];

		if (countys.length > 0) {
			countys.forEach((item) => {
				const center = this.CalSVGCenter(item);
				const titleText = item.querySelector('county').textContent;
				let dataAvarge = item.querySelector('path').getAttribute('data-value');
				const result = dataAvarge !== null ? dataAvarge : '查無資料';

				// 排除金門縣和連江縣，因為它們在離島容器中已經顯示
				if (titleText === '金門縣' || titleText === '連江縣') {
					return;
				}

				places.push({
					x: center.centerOfRect_X,
					y: center.centerOfRect_Y,
					title: titleText,
					average: result
				});
			});
		} else if (towns.length > 0) {
			towns.forEach((item) => {
				const center = this.CalSVGCenter(item);
				const titleText = item.querySelector('town').textContent;
				let dataAvarge = item.querySelector('path').getAttribute('data-value');
				const result = dataAvarge !== null ? dataAvarge : '查無資料';

				places.push({
					x: center.centerOfRect_X,
					y: center.centerOfRect_Y,
					title: titleText,
					average: result
				});
			});
		} else if (village.length > 0) {
			village.forEach((item) => {
				const center = this.CalSVGCenter(item);
				const titleText = item.querySelector('village').textContent;
				let dataAvarge = item.querySelector('path').getAttribute('data-value');
				const result = dataAvarge !== null ? dataAvarge : '查無資料';

				places.push({
					x: center.centerOfRect_X,
					y: center.centerOfRect_Y,
					title: titleText,
					average: result
				});
			});
		}


		// // 使用 d3-force 來避免重疊
		// const simulation = d3.forceSimulation(places)
		// .force("x", d3.forceX(d => d.x).strength(1))
		// .force("y", d3.forceY(d => d.y).strength(1))
		// .force("collide", d3.forceCollide(3))
		// .stop();

		// for (let i = 0; i < places.length; ++i) simulation.tick();



		places.forEach(d => {
			const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");

			textElement.setAttribute("x", d.x);
			textElement.setAttribute("y", d.y);
			textElement.setAttribute("dominant-baseline", "middle");
			textElement.setAttribute("text-anchor", "middle");
			textElement.setAttribute('font-size', fontSize);
			textElement.setAttribute('font-weight', 'bold');

			const titleText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
			titleText.textContent = d.title;
			titleText.setAttribute("x", d.x);
			titleText.setAttribute("dy", "-1em");

			const averageText = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
			averageText.textContent = d.average;
			averageText.setAttribute("x", d.x);
			averageText.setAttribute("dy", "1em");

			textElement.appendChild(titleText);
			textElement.appendChild(averageText);

			mapNames.appendChild(textElement);
		});

	}

	CalSVGCenter = (element) =>
	{
		const mySVG = element;
		// const surroundingRectangle = mySVG.getBoundingClientRect();
		const surroundingRectangle = mySVG.getBBox();
		const centerOfRect_X = surroundingRectangle.x + surroundingRectangle.width * 0.5 ;
		const centerOfRect_Y = surroundingRectangle.y + surroundingRectangle.height * 0.5;
		return {centerOfRect_X, centerOfRect_Y}
	}
	ScaleNum = () =>{
		const svg = document.querySelector('#svgMap');
		if(!svg){return 1}
		const vbWidth = svg.viewBox.baseVal.width;
		const width = svg.getAttribute('width');
		return vbWidth/width;
	}

	handleLoadData = () => {		
		const { sviData } = this.props;
		if (sviData) {
			const { county, town } = sviData;
			const mapData = {
				layer: '',
				data: []
			};

			if (county === '' && town === '') {
				mapData.layer = 'county';
			}
			else if (county !== '' && town === '') {
				mapData.layer = 'town';
			}
			else {
				mapData.layer = 'village';
			}

			sviData.data.forEach(item => {
				const obj = {};
				obj.name = item['name'];
				obj.attribute = {
					'style': {
						'fill': this.handleTransferColor(item.value) ,
						'stroke': '#555555',
					},
					'data-value': item.value,
				}
				mapData.data.push(obj);
			});

			this.setState({
				mapData: mapData,
				county: county,
				town: town,
			})
		}
	}
	handleTransferColor = (value) => {
		const { ranges, colorSet } = this.state		
		let color;
		for (let i = 0; i < ranges.length; i++) {
			if (value > ranges[i] && value <= ranges[i + 1]) {
				color = colorSet[i];
			}
		}
		if (value <= ranges[0]) {
			color = colorSet[0];
		}
		if (value > ranges[ranges.length - 1]) {
			color = colorSet[colorSet.length-1];
		}
		if (value === null || [...new Set(ranges)].length === 1) {
			color = '#eee';
		}
		return color;
	}
	handleMouseOverMap = (area, e) => {
		this.setState({
			isBubbleShow: true,
			bubbleTop: e.clientY,
			bubbleLeft: e.clientX,
			bubble: {
				name: e.target.dataset.name || area.filter(_ => _).slice(-1),
				value: e.target.dataset.value || null
			},
		})
	}
	handleMouseLeaveMap = () => {
		this.setState({
			isBubbleShow: false,
		})
	}
	setColor = (callback) =>{
		const {related} = this.props		
		let colorSet = ['#e05066', '#fd7c8e', '#fd8a9b', '#fea2b0', '#febac4', '#fed4da', '#ffebed', '#ffffff', '#dee8fe', '#cad9fd', '#adc5fc', '#92b2fc', '#7ba1fb', '#6390fa', '#2867f9']
		if(![1,-1].includes(related)) {
			const positive = ['減災整備', '應變能力', '復原能力']
			const negative = ['', '暴露量']
			if(negative.includes(this.props.currentIndicatorName)){
				colorSet = colorSet.reverse()
			}
		} else {
			if(related === 1) {
				colorSet = colorSet.reverse()
			}
		}
		this.getColorBar(colorSet)
		if(callback)
		{			
			this.setState({colorSet},callback);
		}else
		{
			this.setState({colorSet});
		}
	}
	render() {
		const { isMapShow, isBubbleShow, isColorMarkHide, bubbleTop, bubbleLeft, bubble } = this.state;
		const { mapData, county, town } = this.state;
		const { colorSet, ranges, colorBar } = this.state;
		const{zeroPositionPercent,svgId} = this.state;
		
		return (
			<div className={`svi-z-map`}>
				{
					isBubbleShow &&
					<div className="bubble-info"
						style={{
							'position': 'fixed',
							'top': `${bubbleTop}px`,
							'left': `${bubbleLeft}px`,
							'zIndex': 99
						}}>
						<div className="bubble">
							<p className="name">{bubble.name}</p>						
							{ (bubble.value === "0" || Boolean(Number(bubble.value))) && <p className="value">{bubble.value}</p> }
							{ bubble.value !== "0" && !Boolean(Number(bubble.value)) && <p className="value">查無資料</p> }

						</div>
					</div>
				}
				<div className="capture">
					{
						ranges &&
						<div className="range-mark">
							<div className="title" style={{padding:'10px'}}>單位數</div>
							{
								!isColorMarkHide &&
								<React.Fragment>
									<div className="range-noData">
										<div className="colorBar"/>
										<div className="value">查無資料</div>
									</div>
									<div className="range">
										<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
										<div className="valueBar">
											<div className="value type-text -en">{ranges[0].toFixed(2)}</div>
											<div className="value type-text -en zero" style={{top:`${zeroPositionPercent}%`}}>0</div>
											<div className="value type-text -en buttom">{ranges[ranges.length -1].toFixed(2)}</div>
										</div>
									</div>
								</React.Fragment>
							}
						</div>
					}
					<div className={`taiwan-map ${isMapShow && '-show'}`} onMouseLeave={this.handleMouseLeaveMap}>
						{
							mapData &&
							mapData.layer === 'county' &&
							<MapIsland
								onAreaHover={this.handleMouseOverMap}
								infoData={mapData}
								/>
						}
						<SvgZoomMap
							countyJsonSrc="/MapJson/taiwan-county.json"
							townJsonSrc="/MapJson/taiwan-town.json"
							villageJsonSrc="/MapJson/taiwan-village.json"
							onAreaHover={this.handleMouseOverMap}
							county={county}
							town={town}
							infoData={mapData}
							zoomDelay={0}
							isMapInit={() => { this.setState({ isMapShow: true }) }}
							ignoreArea={mapData && mapData.layer === 'county' ? ['金門縣', '連江縣'] : []}
						/>
					</div>
				</div>

				<div className="captureText captureText-hidden" style={{position:'fixed',top:'-9999px', left:'0', width:'880px'}} >
				{/* 地圖 */}
				{
						ranges &&
						<div className="range-mark" style={{top:'auto', left:'auto'}}>
							<div className="title" style={{padding:'10px'}}>單位數</div>
							{
								!isColorMarkHide &&
								<React.Fragment>
									<div className="range-noData">
										<div className="colorBar"/>
										<div className="value">查無資料</div>
									</div>
									<div className="range">
										<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
										<div className="valueBar">
											<div className="value type-text -en">{ranges[0].toFixed(2)}</div>
											<div className="value type-text -en zero" style={{top:`${zeroPositionPercent}%`}}>0</div>
											<div className="value type-text -en buttom">{ranges[ranges.length -1].toFixed(2)}</div>
										</div>
									</div>
								</React.Fragment>
							}
						</div>
					}
					<div className={`taiwan-map ${isMapShow && '-show'}`} onMouseLeave={this.handleMouseLeaveMap} >
						{
							mapData &&
							mapData.layer === 'county' &&
							<MapIsland
								onAreaHover={this.handleMouseOverMap}
								infoData={mapData}
								showName={true} />
						}
						<SvgZoomMap
							svgId={svgId}
							countyJsonSrc="/MapJson/taiwan-county.json"
							townJsonSrc="/MapJson/taiwan-town.json"
							villageJsonSrc="/MapJson/taiwan-village.json"
							onAreaHover={this.handleMouseOverMap}
							county={county}
							town={town}
							infoData={mapData}
							zoomDelay={0}
							isMapInit={() => { this.setState({ isMapShow: true }) }}
							isMapUpdate = {() =>{this.MapInit();}}
							disableResize={true}
						/>
					</div>

				{/* 說明文字 */}
				<div className="info capture">
					{
						this.props.currentIndicatorId == 0 &&
						<>
							<div className="title">說明</div>
							<div className="content">上圖展示各縣市社會脆弱度綜合指數（Z），依據本站所列之指標項目進行綜合計算而得（詳首頁說明），指數越大表示脆弱度越高。部分年度／縣市因缺乏資料，無法計算。</div>
							<div className="content">顏色辨識：紅色＝高社會脆弱度，藍色＝低社會脆弱度。</div>
						</>
					}
					{
						this.props.categoryDescription &&
						this.props.categoryDescription.map((category, i) =>
						(
							category.name === this.props.currentIndicatorName &&
							<React.Fragment key={i}>
								<div className="title">{category.name}</div>
								<div className="content" dangerouslySetInnerHTML={{ __html: category.description }}></div>
							</React.Fragment>
						)
						)
					}
					{
						(this.props.currentIndicatorDescription && this.props.currentIndicatorDescription !== '') &&
						<>
							<div className="title">指標定義說明</div>
							<div className="content" dangerouslySetInnerHTML={{ __html: this.props.currentIndicatorDescription }}></div>
						</>
					}
				</div>
				</div>
			</div>
		);
	}
}

export default SviChartMap;
